"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./empty-page.component.css.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./empty-page.component");
var i3 = require("../../Services/service.service");
var styles_EmptyPageComponent = [i0.styles];
var RenderType_EmptyPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_EmptyPageComponent, data: {} });
exports.RenderType_EmptyPageComponent = RenderType_EmptyPageComponent;
function View_EmptyPageComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "p", [], null, null, null, null, null))], null, null); }
exports.View_EmptyPageComponent_0 = View_EmptyPageComponent_0;
function View_EmptyPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-empty-page", [], null, null, null, View_EmptyPageComponent_0, RenderType_EmptyPageComponent)), i1.ɵdid(1, 114688, null, 0, i2.EmptyPageComponent, [i3.MainService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_EmptyPageComponent_Host_0 = View_EmptyPageComponent_Host_0;
var EmptyPageComponentNgFactory = i1.ɵccf("app-empty-page", i2.EmptyPageComponent, View_EmptyPageComponent_Host_0, {}, {}, []);
exports.EmptyPageComponentNgFactory = EmptyPageComponentNgFactory;
